export default "__VITE_ASSET__bad54bec__"